<template>
  <div>
    <el-form
      size="mini"
      ref="form"
      :model="formData"
      :rules="rules"
      label-position="top"
      v-loading.fullscreen.lock="loading"
      element-loading-text="loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="拒收原因" prop="reason" size="small">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入拒收原因"
              v-model="formData.reason"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    listOrder: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      formData: { reason: '' },
      rules: {
        reason: [
          { required: true, message: '请输入拒收原因', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.$confirm(
        '确认要对当前的运输订单，进行【拒收】操作吗？',
        '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        const listCode = this.listOrder.map((item) => item.waybillDetailCode)
        this.loading = true
        this.$api
          .carriageWaybillDetailIsRejectedApi({
            listCode,
            ...this.formData,
          })
          .then((res) => {
            this.loading = false
            this.$emit('close')
            this.$emit('reload')
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
  },
}
</script>
